module.exports = __webpack_public_path__ + "img/logo_tanoc2.6fb99001.png";